import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import MonitorServices from "./monitor.services";
import toastr from "toastr";
import { downloadDocument } from "../../../components/gestorDocumental/GestorDocumental";

export const getMonitor = (params, history) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_MONITOR,
      payload: true,
    });
    const resp = await MonitorServices.getMonitor(params);
    const respuestaMensaje = resp.data.mensaje;
    const tipoMensaje = typeof respuestaMensaje;
    if (tipoMensaje === "string") {
      dispatch({
        type: actions.GET_MONITOR,
        payload: {
          monitor: [],
          monitorLength: 0,
        },
      });
      dispatch({
        type: actions.GET_MONITOR_FAIL,
        payload:
          respuestaMensaje.charAt(0).toUpperCase() +
          respuestaMensaje.slice(1) +
          "!",
      });
    } else {
      dispatch({
        type: actions.GET_MONITOR,
        payload: {
          monitor: resp.data.mensaje,
          monitorLength: resp.data.count,
        },
      });
      dispatch({
        type: actions.GET_MONITOR_FAIL,
        payload: "",
      });
    }
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.GET_MONITOR_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_MONITOR,
      payload: false,
    });
  }
};

export const saveCopia =
  (data, tipo, offset, limit, filter, tipoBusqueda) =>
  async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.SAVE_LOADING_MONITOR,
        payload: true,
      });
      await MonitorServices.saveCopia(data);
      dispatch(
        getMonitor({
          offset: offset,
          limit: limit,
          filter: filter,
          tipo_busqueda: tipoBusqueda,
          tipo_workflow: parseInt(tipo) === 1 ? "[1]" : "[2,3]",
          // JSON.stringify([parseInt(tipo)]),
        })
      );
      toastr.success(messages.successMessage);
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + ex.response.statusText;
              break;
            case 404:
              toastr.error(ex.response.data.mensaje);
              break;
            case 500:
              message = messages.errorMessage + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.COPIA_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.SAVE_LOADING_MONITOR,
        payload: false,
      });
    }
  };

export const saveDadoDeBaja =
  (req, getWfRespMonitor) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.SAVE_LOADING_MONITOR,
        payload: true,
      });
      await MonitorServices.saveDadoDeBaja(req);
      getWfRespMonitor();
      // const { data, count } = getState().monitorOnBoarding.dadoDeBaja;
      // dispatch({
      //     type: actions.GET_MONITOR,
      //     payload: {
      //         count: count + 1,
      //         data: [...data, resp.data]
      //     },
      // });

      // dispatch({
      //     type: actions.FORM_APPROACHES_FAIL,
      //     payload: "",
      // });
      // setShowModal(false);
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = ex.response.data;
              break;
            case 404:
              if (ex.response.data && ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = messages.notFound;
              }
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 403:
              if (ex.response.data && ex.response.data.detail) {
                message = ex.response.data.detail;
              } else {
                message = messages.notFound;
              }
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.DADO_DE_BAJA_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.SAVE_LOADING_DADO_DE_BAJA,
        payload: false,
      });
    }
  };

export const deleteWorkflow = (id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_MONITOR,
      payload: true,
    });
    await MonitorServices.deleteWorkflow(id);
    const { monitor, monitorLength } = getState().monitorOnBoarding;
    monitor.splice(index, 1);

    dispatch({
      type: actions.GET_MONITOR,
      payload: {
        monitor: monitor,
        monitorLength: monitorLength - 1,
      },
    });

    toastr.success(messages.successMessage);
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 500:
            message = messages.errorMessage + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    toastr.error(message);
  } finally {
    dispatch({
      type: actions.SAVE_LOADING_MONITOR,
      payload: false,
    });
  }
};

export const getBoardingManual = (id, filename, setLoader) => async () => {
  try {
    setLoader(true);
    const resp = await MonitorServices.getBoardingManual(id);
    downloadDocument(
      `data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64,${resp.data.documento}`,
      `${filename}.docx`
    );
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if (ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.errorMessage + " " + ex.response.statusText;
            }
            break;
          case 404:
            if (ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.errorMessage + " " + ex.response.statusText;
            }
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    toastr.error(message, "", {
      progressBar: true,
      rtl: true,
    });
  } finally {
    setLoader(false);
  }
};
